import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const AddParticipants = ({ participants, setParticipants, onContinue }) => {
  const [name, setName] = useState('');

  const handleAdd = () => {
    if (!name.trim()) return;

    const newParticipant = {
      id: Date.now().toString(),
      name: name.trim(),
    };

    setParticipants([...participants, newParticipant]);
    setName('');
  };

  const handleRemove = (id) => {
    setParticipants(participants.filter((p) => p.id !== id));
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto' }}>
      {/* Form för att lägga till deltagare */}
      <Stack direction="row" spacing={1} mb={2}>
        <TextField
          label="Namn"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
          fullWidth
        />
        <Button variant="contained" color="primary" onClick={handleAdd}>
          Lägg till
        </Button>
      </Stack>

      {/* Lista över deltagare */}
      <List>
        {participants.map((p) => (
          <ListItem
            key={p.id}
            secondaryAction={
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => handleRemove(p.id)}
              >
                <DeleteIcon />
              </IconButton>
            }
          >
            <ListItemText primary={p.name} />
          </ListItem>
        ))}
      </List>

      {/* Fortsätt-knapp */}
      {participants.length >= 2 && (
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Button variant="contained" color="secondary" onClick={onContinue}>
            Fortsätt
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default AddParticipants;
